// extracted by mini-css-extract-plugin
export default {"title":"RedactGameComponent_title__KHedE","wrapper_button":"RedactGameComponent_wrapper_button__NHpTK"};